import { render, staticRenderFns } from "./Traingaiqiantuipiao.vue?vue&type=template&id=7a9ff94d&scoped=true"
import script from "./Traingaiqiantuipiao.vue?vue&type=script&lang=js"
export * from "./Traingaiqiantuipiao.vue?vue&type=script&lang=js"
import style0 from "./Traingaiqiantuipiao.vue?vue&type=style&index=0&id=7a9ff94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ff94d",
  null
  
)

export default component.exports